type SchoolLogoProps = {
  compact?: boolean
  authority?: string
  name?: string
  slogan?: string
  logoUrl?: string
}

export function SchoolLogo({
  compact = false,
  authority = 'UBND PHƯỜNG QUẢNG PHÚ',
  name = 'TRƯỜNG THCS LÝ THƯỜNG KIỆT',
  slogan = 'ĐOÀN KẾT – TỰ TRỌNG – NHÂN ÁI – TẬN TÂM – SÁNG TẠO',
  logoUrl = '/assets/images/logo.png',
}: SchoolLogoProps) {
  const upperName = name.toUpperCase()
  const titleMatch = upperName.match(/(LÝ THƯỜNG KIỆT)$/)
  const schoolLine = titleMatch ? upperName.replace(titleMatch[1], '').trim() : upperName
  const titleLine = titleMatch?.[1]

  return (
    <div className={`school-brand ${compact ? 'school-brand--compact' : ''}`}>
      {logoUrl ? (
        <img className="school-logo" src={logoUrl} alt="Logo trường" />
      ) : (
        <svg className="school-logo" viewBox="0 0 100 100" aria-label="Logo trường">
          <circle cx="50" cy="50" r="47" fill="#fff" stroke="#00756f" strokeWidth="4" />
          <circle cx="50" cy="50" r="38" fill="none" stroke="#ef4b32" strokeWidth="2" />
          <path d="M50 17 C42 28 42 35 50 42 C58 35 58 28 50 17Z" fill="#e3212e" />
          <path d="M36 43 H64 L60 72 H40Z" fill="#00756f" />
          <path d="M42 49 L50 58 L58 49" fill="none" stroke="#ffd332" strokeWidth="4" />
          <text x="50" y="67" textAnchor="middle" fontSize="14" fontWeight="700" fill="#ffd332">LTK</text>
          <text x="50" y="89" textAnchor="middle" fontSize="8" fontWeight="700" fill="#00756f">2011</text>
        </svg>
      )}
      <div>
        {!compact && <div className="school-authority">{authority}</div>}
        <div className="school-name">{schoolLine} {titleLine}</div>
        {/* {titleLine && <div className="school-title">{titleLine}</div>} */}
        {!compact && <div className="school-slogan">{slogan}</div>}
      </div>
    </div>
  )
}
